import { Clear } from './icons/Clear';
import { FiltersInactive } from './icons/FiltersInactive';
import { FiltersActive } from './icons/FiltersActive';
import { Search } from './icons/Search';
import { HeaderProps } from '../types/HeaderProps';

export const Header = ({
  openFilterModal,
  educationFilter,
  genderFilter,
  search,
  setSearch
}: HeaderProps) => {
  return (
    <header className='bg-bluestone-light pt-3 pb-4 px-4 md:relative md:z-10 md:rounded-t-3xl'>
      <div className='flex justify-center pb-4'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='40'
          height='33'
          fill='none'>
          <path
            fill='#FFDF00'
            d='M24.045 11.886h3.607L20.785 0v8.636c0 3.25 2.524 3.25 3.26 3.25ZM15.965 11.886c.726 0 3.26 0 3.26-3.25V0l-6.867 11.886h3.607ZM15.578 13.297h-4.035L.69 32.089h.914c1.113 0 2.156-.02 3.13-.05l9.034-16.526-5.217 16.268c1.55-.159 2.882-.377 4.024-.646l3.816-12.432-.924 11.468c3.33-1.55 3.757-3.885 3.757-6.46v-6.807c0-3.627-2.823-3.627-3.637-3.627M24.422 13.297h4.035L39.31 32.099h-.914c-1.113 0-2.147-.02-3.13-.05L26.23 15.524l5.217 16.268c-1.55-.159-2.881-.377-4.024-.646l-3.817-12.432.925 11.468c-3.33-1.55-3.757-3.885-3.757-6.46v-6.807c0-3.627 2.823-3.627 3.637-3.627'
          />
        </svg>
      </div>
      <div className='relative rounded-full focus-within:shadow-search-bar'>
        <Search variant='dark' className='absolute top-4 left-4' />
        <input
          type='text'
          className='py-4 pl-[46px] rounded-full w-full border-white !outline-none !ring-0 placeholder-[#606F82] text-bluestone-light'
          placeholder='Search...'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        />
        {search && (
          <div className='cursor-pointer' onClick={() => setSearch('')}>
            <Clear
              variant='dark'
              className='absolute top-4 right-[75px] cursor-pointer'
            />
          </div>
        )}
        <div
          className='absolute border-l pl-4 top-4 right-5 cursor-pointer'
          onClick={openFilterModal}>
          {educationFilter !== 'All' || genderFilter !== 'All' ? (
            <FiltersActive variant='dark' />
          ) : (
            <FiltersInactive variant='dark' />
          )}
        </div>
      </div>
    </header>
  );
};
